import React from "react";
import axios from "axios";
import $ from "jquery";
import {
    getFromLocalStorage,
    sendToLocalStorage
} from './Utilities';

class ApplicationList extends React.Component {
    constructor(props){
        super(props);
        
        this.ApplicationList = React.createRef();

        const apps = getFromLocalStorage("applications_dropdown");
        this.state = {
            apps: apps,
            selected: {}
        }

    }

    componentDidMount(){
        if(Object.keys(this.state.apps).length === 0) this.getData();
        else if(this.props.type === "select") this.createSelect();
    }

    getData(){     
        axios.get("DashboardPage_Controller/getApplicationsList?viaAjax=1&turnoffdebug=1")
            .then(response => this.formatData(response.data));
    }

    formatData(data){
        data = sendToLocalStorage("applications_dropdown", JSON.stringify(data));

        var apps = {};

        Object.values(data).map(function(obj, key) {
            if(obj.Default) obj.Name += " (default)";
            apps[key] = obj;
        });

        this.setState({
            "apps": apps
        });

        if(this.props.type === "select") return this.createSelect();
    }

    createSelect(){
        const apps = this.state.apps;
        var selected = this.props.value;
        var selectedApp = {};
        if(selected) selectedApp = this.getSelected(selected);
        if(Object.keys(selectedApp).length > 0){
            this.setState({
                selected: selectedApp
            });
        }   

        var parent = this;
        $(this.ApplicationList.current).on('change', function(event, val) {
            selectedApp = parent.getSelected($(this).val());
            if(Object.keys(selectedApp).length > 0){
                parent.setState({
                    selected: selectedApp
                });
                parent.props.onChange(selectedApp);
            }
        });
        $(this.ApplicationList.current).select2();   
    }

    getSelected(appID){
        var selectedApp = {};
        Object.entries(this.state.apps).filter(function(app, key){
            if(parseInt(app[1].ID) === parseInt(appID)) selectedApp = app[1];
        });
        return selectedApp;
    }

    render(){
        const apps = this.state.apps ? this.state.apps : {};
        if(this.props.type === "select") return this.renderSelect();
    }

    renderSelect(){  
        const { apps, selected } = this.state;

        return(
            <div>
                <select id="AppSelector" className="form-control" ref={this.ApplicationList} value={selected?.ID}>
                    {Object.entries(apps).map(function(obj, key) {
                       return <option key={key} value={obj[1].ID}>{obj[1].Name}</option>;
                    })}
                </select>
            </div>
        );
    }

}

export default ApplicationList;